<template>
    <div class="md-sold-estimate fashion">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div v-if="cmpTitle" class="mg-title" v-html="formatFontSize(cmpTitle, '--mg-title-size')"></div>
            <div class="box">
                <p class="text">{{ $t('md-sold-estimate.estprice') }}</p>
                <p class="est-price">{{ estPriceValue }}</p>
                <p class="diff-price" v-if="diffPrice && diffValueDesc">
                    <span
                        class="value"
                        :class="{
                            up: diffPrice > 0,
                            down: diffPrice < 0
                        }"
                    >{{ diffPriceValue }}</span
                    >
                    <span class="desc">{{ diffValueDesc }}</span>
                </p>
                <p class="price-desc">{{ cmpDesc }}</p>
                <div class="request">
                    <button @click="openRegisterPop">
                        {{ cmpRequestButtonText }}
                    </button>
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../common';
export default {
    mixins: [common],
    data: function() {
        return {};
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.md-sold-estimate.fashion {
    p {
        text-align: center;
        line-height: normal;
    }
    .box {
        background-color: #f5f6fa;
        padding: 40px 0 40px 0;

        .text {
            font-size: 14px;
            color: #8b93a7;
        }
        .est-price {
            margin-top: 7px;
            font-size: 32px;
            color: #4a4a60;
            font-family: var(--font-bold);
        }
        .diff-price {
            font-family: var(--font-bold);
            margin-top: 5px;
            font-size: 16px;
            .value {
                &.down {
                    color: #ff5661;
                }
                &.up {
                    color: #29cb97;
                }
            }
            .desc {
                color: #4a4a60;
            }
        }
        .price-desc {
            margin-top: 30px;
            font-size: 14px;
            color: #8b93a7;
        }
        .request {
            text-align: center;
            margin-top: 12px;
            button {
                font-family: var(--font-bold);
                font-size: 16px;
                padding: 10px 25px;
                min-width: 343px;
                @include color-button();
            }
        }
    }
}
</style>
